import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
export const defaultSortModel: GridSortModel = [
  { field: 'firstName', sort: 'asc' },
  { field: 'lastName', sort: 'asc' },
]
export const defaultVisibilityModel: GridColumnVisibilityModel = { deleted: false }
export const defaultColumnOrder = [
  'image_512',
  'name',
  'firstName',
  'lastName',
  'email',
  'title',
  'role',
  'deleted',
  'phone',
  'linkedIn',
  'user_uuid',
]
